import { render, staticRenderFns } from "./MallDetail.vue?vue&type=template&id=41ccb782&scoped=true"
import script from "./MallDetail.vue?vue&type=script&lang=js"
export * from "./MallDetail.vue?vue&type=script&lang=js"
import style0 from "./MallDetail.vue?vue&type=style&index=0&id=41ccb782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ccb782",
  null
  
)

export default component.exports